import React from 'react';
import { PageHeader } from 'src/components/Settings/components';
import { TabNavigation } from '../TabNavigation';

interface StrategyManagerLayoutProps {
  children: React.ReactNode;
}

const StrategyManagerLayout = ({ children }: StrategyManagerLayoutProps) => {
  return (
    <div className="flex flex-col gap-3">
      <PageHeader>
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <h1 className="text-xl font-semibold text-primary">
              Strategy Administration
            </h1>
            <div className="text-sm text-tertiary">Manage your strategies</div>
          </div>
        </div>
      </PageHeader>

      <TabNavigation />

      {children}
    </div>
  );
};

export default StrategyManagerLayout;
